import { ReactNode } from 'react';
import { IComponentCss } from '@tap/mui-ui';
import { Typography } from '@mui/material';

/*
*   Заголовок страниц (Основной H1)
*/


type TitlePageH1Props = {
    children: ReactNode,
}

const css: IComponentCss = {
    title: { mb: 2 },
};

export function TitlePageH1({ children }: TitlePageH1Props) {

    return (
        <Typography
            component='h1'
            variant='h4'
            sx={css.title}
        >
            {children}
        </Typography>
    );
}